import { StepDefinition } from "../../../../../../../model/workflows/step-definition";
import { Department } from "../../../../../../../model/departments/department";
import { PenIcon, DeleteIcon, DragIndicatorIcon, StepIcon, DepartmentIcon } from "../../../../../../../assets/icons";
import styles from "./WorkflowStepCard.module.scss";

interface WorkflowStepCardProps {
	step: StepDefinition;
	index: number;
	isActive: boolean;
	departments?: Department[];
	onClick: () => void;
	onEdit: (e: React.MouseEvent) => void;
	onDelete: (e: React.MouseEvent) => void;
	onReorder: (e: React.MouseEvent) => void;
}

const WorkflowStepCard = ({ step, index, isActive, departments, onClick, onEdit, onDelete, onReorder }: WorkflowStepCardProps) => {
	return (
		<div
			className={`${styles.stepCard} ${isActive ? styles.stepCardActive : ""}`}
			onClick={onClick}
			onMouseDown={e => {
				// Prevent card click when clicking on action buttons
				if ((e.target as HTMLElement).closest(`.${styles.actionButton}`)) {
					e.stopPropagation();
				}
			}}
		>
			<div className={styles.stepCardContent}>
				<div className={styles.stepCardHeader}>
					<div className={styles.stepIcon}>
						<StepIcon />
					</div>
					<div className={styles.stepInfo}>
						<div className={styles.stepNumber}>Step {index + 1}</div>
						<div className={styles.stepName}>{step.name || "Name"}</div>
					</div>
					<div className={styles.stepActions}>
						<button className={styles.actionButton} onClick={onEdit}>
							<PenIcon />
						</button>
						<button className={styles.actionButton} onClick={onDelete}>
							<DeleteIcon />
						</button>
						<div className={styles.dragHandle} onMouseDown={onReorder}>
							<DragIndicatorIcon />
						</div>
					</div>
				</div>
				<div className={styles.stepInfo}>
					<div className={styles.stepDescription}>{step.description}</div>
						<div className={styles.stepRoles}>
							
							{step.stepDefinitionDepartments?.map(d => {
							const deptName = departments?.find(dept => dept.id === d.departmentId)?.name ?? d.name ?? d.departmentId;
							return <div key={d.departmentId} className={styles.stepRoleItem}><DepartmentIcon /> {deptName}</div>;
						})}
						
					</div>

				</div>
			</div>
		</div>
	);
};

export default WorkflowStepCard;
